import { Button, Col, Pagination } from "antd";
import { Link } from "react-router-dom";
import { APP_ROUTES, MAIN_ROUTES } from "../../../../_config/routes";

export default function TableClientsPaged({ hook }){
    return(
        <Col xs={24} lg={24}>
            <Pagination 
                onChange={(e) => {
                    hook.setPage(e - 1);
                    hook.loadData(e - 1, hook.count);
                }} 
                current={hook.page + 1} 
                pageSize={hook.count}
                total={hook.pagedData.total} 
                showSizeChanger={false}
            />
            <table style={{ margin: '10px 0', width: '100%' }}>
                <tr>
                    <th style={{ borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc', width: '50%' }}>
                        Cliente
                    </th>
                    <th style={{ borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc' }}></th>
                    <th style={{ borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc' }}></th>
                    <th style={{ borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc' }}></th>
                </tr>
                {
                    hook.pagedData.data.map((client, key) => {
                        return(
                            <tr key={`table_client_${key}`}>
                                <td style={{ borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc' }}>
                                    {client.name}
                                </td>
                                <td style={{ borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc' }}>
                                    <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.general_client_info_live}?client=${client.uuid}`}>
                                        <Button type="primary">
                                            Pedidos en proceso
                                        </Button>
                                    </Link>
                                </td>
                                <td style={{ borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc' }}>
                                <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.general_client_info_departures}?client=${client.uuid}`}>
                                        <Button type="primary">
                                            Pedidos despachados
                                        </Button>
                                    </Link>
                                </td>
                                <td style={{ borderTop: '1px solid #ccc', borderBottom: '1px solid #ccc' }}>
                                    <Link to={`${MAIN_ROUTES.app_modules}${APP_ROUTES.general_client_info_all}?client=${client.uuid}`}>
                                        <Button type="primary">
                                            Todos los pedidos
                                        </Button>
                                    </Link>
                                </td>
                            </tr>
                        );
                    })
                }
            </table>
            <Pagination 
                onChange={(e) => {
                    hook.setPage(e - 1);
                    hook.loadData(e - 1, hook.count);
                }} 
                current={hook.page + 1} 
                pageSize={hook.count}
                total={hook.pagedData.total} 
                showSizeChanger={false}
            />
        </Col>
    );
}